import { FaBars } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import { useMemo } from "react";
import AddTeamChip from "./AddTeamChip";
import NotificationBell from "./NotificationBell";

const pageNames = {
  "/": "Home",
  "/players": "Players",
  "/compare": "Compare Players",
  "/s16": "S16",
  "/captainmode": "Captain Mode",
  "/league-stats": "League Stats",
  "/elimination": "Elimination",
  "/fpllive": "FPL Live",
  "/clean-sheet": "Clean Sheet Chances",
  "/check-registration": "Check Registration",
  "/the-100": "THE 100",
  "/my-team": "My Team",
  "/history": "History",
  "/squad-compare": "Squad Compare",
  "/versus": "Versus",
  "/tieanalyzer": "Tie Analyzer",
  "/dream-team": "Team of the Week",
  "/suggestion": "Top Picks",
  "/injuries": "Injuries & Suspensions",
};

const Navbar = ({ toggleSidebar, showMenu = true }) => {
  const { pathname } = useLocation();
  const title = useMemo(() => pageNames[pathname] || "FPL Nepal", [pathname]);

  return (
    <header className="fpl-topbar sticky top-0 z-30">
      <div className="fpl-topbar-left">
        {showMenu && (
          <button onClick={toggleSidebar} className="fpl-mobile-menu" aria-label="Collapse or expand menu">
            <FaBars />
          </button>
        )}
        <div className="fpl-page-id hidden lg:block">
          <div className="fpl-topbar-kicker">FPL Nepal <span>2026/27</span></div>
          <h1 className="fpl-topbar-title">{title}</h1>
        </div>
      </div>

      <div className="fpl-topbar-actions">
        <AddTeamChip />
        <NotificationBell />
      </div>
    </header>
  );
};

export default Navbar;
